import { InformationCircleOutlineIcon } from 'assets/svgs';
import { AxiosError } from 'axios';
import axios from 'common/AxiosAuth';
import { Button, Input, Label, Modal, ModalInner } from 'components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ModalProps {
  isOpen: boolean;  // 모달의 열림 상태
  onConfirm: () => void; 
  onCancel: () => void;  
}

const ChangePassword = ({ isOpen, onConfirm, onCancel }: ModalProps) => {
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [newPasswordError, setNewPasswordError] = useState<string>('');
  const [confirmPasswordError, setConfirmPasswordError] = useState<string>('');
  const [currentPasswordError, setCurrentPasswordError] = useState<string>('');

    //영문/숫자/특수문자 최소 한 개 이상으로 구성 최소 8자 이상
  const passwordRegexp = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/);

  const { t } = useTranslation();
  

  useEffect(() => {
    let newPasswordError = '';
    let confirmPasswordError = '';

    // 입력이 시작된 경우에만 검사를 수행
    if (newPassword || confirmPassword) {
      if (newPassword && !passwordRegexp.test(newPassword)) {
        newPasswordError = t('myPage.changePassword.error.weak');
      } else if (newPassword !== confirmPassword) {
        confirmPasswordError = t('myPage.changePassword.error.mismatch');
      }
      setNewPasswordError(newPasswordError);
      setConfirmPasswordError(confirmPasswordError);
    } 
  }, [newPassword, confirmPassword]);

  const handleConfirm = async () => {
    if (newPasswordError || confirmPasswordError) {
      return;
    }

    try {
      await axios.post('/api/member/change-password', {
        currentPassword,
        newPassword
      });
      onConfirm();
      onCancel(); 
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 400) {
          const method = (error.response?.data as any)?.method;
          if (method === 'SAME_PASSWORD') {
            setCurrentPasswordError('');
            setNewPasswordError(t('myPage.changePassword.error.samePassword'));
          } else {
            setCurrentPasswordError(t('myPage.changePassword.error.wrongCurrent'));
          }
        } else {
          console.error('An error occurred while changing the password', error.response?.data?.message);
        }
      }
    }
  };

  return (
    <Modal isOpened={isOpen} >
      <ModalInner className="md:w-[400px]" title={t('myPage.changePassword.title')} onClickClose={onCancel}>
        <div className='px-4 pb-4'>
          <Input className='pb-2' label={t('myPage.changePassword.current')} type="password" value={currentPassword} setValue={setCurrentPassword} errorMessage={currentPasswordError}/>
          <Input className='pb-1' label={t('myPage.changePassword.new')}  type="password" errorMessage={newPasswordError} value={newPassword} setValue={setNewPassword} />
          <Input className='py-1' label={t('myPage.changePassword.confirm')}  type="password" value={confirmPassword} setValue={setConfirmPassword}  errorMessage={confirmPassword && newPassword !== confirmPassword ? t('myPage.changePassword.error.mismatch')  : ''}/>
        </div>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text={t('myPage.changePassword.cancel')}  onClick={onCancel} type="secondary" size="large" />
          <Button 
            className="h-9" 
            type='primary' 
            text={t('myPage.changePassword.submit')} 
            onClick={handleConfirm} 
            size="large" 
            disabled={!currentPassword || !newPassword || !confirmPassword || !!newPasswordError || !!confirmPasswordError}
          />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default ChangePassword;